export const DATA_WORKS_STATUS_MAP: Record<string, string> = {
  CREATED: 'Created',
  IN_TEMP: 'In Temp',
  READY_FOR_BOOKING: 'Ready for Booking',
  PROCESSED: 'Processed',
};

export const isDataWorksExportEnabled = (params: {
  arrestDate?: Date | string | null;
  kaseNumber?: string | null;
  dataWorksStatus?: string | null;
}) => !!params.arrestDate && !!params.kaseNumber && !params.dataWorksStatus;
